import { BreadcrumbModel } from 'app/common/model/breadcrumb.model';
import { ColorType, LayoutType, PaperSizeType, StapleOptionType } from '../../models/graphql';

export const PAGINATION_CONFIG: number[] = [10, 20, 50, 100];

// Shared breadcrumb navigation for customer context
export const CUSTOMER_NAVIGATION: BreadcrumbModel[] = [
    {
        id: 'customers',
        name: 'Customers',
        url: '/customers/customerList',
        key: 'customer-list'
    }
];

export const LANGUAGES_TO_SHOW: string[] = ['ar', 'da', 'de', 'el', 'en', 'en-AU', 'en-CA', 'en-NZ', 'en-UK', 'es', 'fa', 'fr', 'ga', 'he', 'hi', 'id', 'it', 'iw', 'ko', 'ms', 'pl', 'pt', 'ru', 'si', 'sv', 'th', 'tl', 'tr', 'vi', 'zh-CN', 'zh-TW'];


export const DUPLEX = [
    {
        name: 'oneSidedLabel',
        value: false
    },
    {
        name: 'twoSidedLabel',
        value: true
    },
];

export const DEVICE_DUPLEX = [
    {
        name: 'OneSided',
        value: 'OneSided',
        displayName: 'One Sided',
        display: false
    },
    {
        name: 'TwoSided',
        value: 'TwoSided',
        displayName: 'Two Sided',
        display: false
    },
];

export const COLOR = [
    {
        name: 'grayscaleLabel',
        value: ColorType.Grayscale,
        displayName: 'Grayscale',
        display: false
    },
    {
        name: 'colorLabel',
        value: ColorType.Color,
        displayName: 'Color',
        display: false
    }
];
export const ORIENTATION = [
    {
        name: 'asSavedLabel',
        value: LayoutType.AsSaved,
        display: false
    },
    {
        name: 'portraitLabel',
        value: LayoutType.Portrait,
        display: false
    },
    {
        name: 'landscapeLabel',
        value: LayoutType.Landscape,
        display: false
    }
];


export const STAPLE_OPTION = [
    {
        name: 'labelNone',
        value: StapleOptionType.None,
        display: true
    },
    {
        name: 'labelTopLeft',
        value: StapleOptionType.StapleTopLeft,
        display: true
    },
    {
        name: 'labelTopRight',
        value: StapleOptionType.StapleTopRight,
        display: true
    },
    {
        name: 'labelBottomLeft',
        value: StapleOptionType.StapleBottomLeft,
        display: true
    },
    {
        name: 'labelBottomRight',
        value: StapleOptionType.StapleBottomRight,
        display: true
    }
];

export const DEVICE_ORIENTATION = [
    {
        name: 'LandScape',
        value:'LandScape',
        displayName: 'Landscape'
    },
    {
        name: 'Portrait',
        value: LayoutType.Portrait,
        displayName: 'Portrait'
    },
];

export const PAPER_SIZE = [
    {
        name: 'labelA3',
        value: PaperSizeType.A3
    },
    {
        name: 'labelA4',
        value: PaperSizeType.A4
    },
    {
        name: 'labelLedger',
        value: PaperSizeType.Ledger
    },
    {
        name: 'labelLegal',
        value: PaperSizeType.Legal
    },
    {
        name: 'labelLetter',
        value: PaperSizeType.Letter
    },
    {
        name: 'labelTabloid',
        value: PaperSizeType.Tabloid
    }
];

export const DEVICE_PAPER_SIZE = [
    {
        name: 'Letter',
        value: PaperSizeType.Letter
    },
    {
        name: 'Legal',
        value: PaperSizeType.Legal
    },
    {
        name: 'Ledger',
        value: PaperSizeType.Ledger
    },
    {
        name: 'Tabloid',
        value: PaperSizeType.Tabloid
    },
    {
        name: 'A4',
        value: PaperSizeType.A4
    },
    {
        name: 'A3',
        value: PaperSizeType.A3
    }
];

export const SUPPORTED_LANGUAGES = [
    {
        language: 'Arabic',
        locale: 'ar',
        flagLang: 'sa',
        currency: 'SAR',
        date: 'ar-SA',
        currencySymbol: '﷼'
    },
    {
        language: 'Chinese Simplified',
        locale: 'zh-CN',
        flagLang: 'cn',
        currency: 'CNY',
        date: 'zh-CN',
        currencySymbol: '¥'
    },
    {
        language: 'Chinese Traditional',
        locale: 'zh-TW',
        flagLang: 'cn',
        currency: 'CNY',
        date: 'zh-TW',
        currencySymbol: '¥'
    },
    {
        language: 'English',
        locale: 'en',
        flagLang: 'us',
        currency: 'USD',
        date: 'en-US',
        currencySymbol: '$'    },
    {
        language: 'English',
        locale: 'en-UK',
        flagLang: 'gb',
        currency: 'GBP',
        date: 'en-GB',
        currencySymbol: '£',
    },
    {
        language: 'English',
        locale: 'en-AU',
        flagLang: 'au',
        currency: 'AUD',
        date: 'en-AU',
        currencySymbol: '$',
    },
    {
        language: 'English',
        locale: 'en-CA',
        flagLang: 'ca',
        currency: 'CAD',
        date: 'en-CA',
        currencySymbol: '$',
    },
    {
        language: 'English',
        locale: 'en-NZ',
        flagLang: 'nz',
        currency: 'NZD',
        date: 'en-NZ',
        currencySymbol: '$',
    },
    {
        language: 'French',
        locale: 'fr',
        flagLang: 'fr',
        currency: 'EUR',
        date: 'fr-FR',
        currencySymbol: '€'
    },
    {
        language: 'German',
        locale: 'de',
        flagLang: 'de',
        currency: 'EUR',
        date: 'de-DE',
        currencySymbol: '€'
    },
    {
        language: 'Greek',
        locale: 'el',
        flagLang: 'gr',
        currency: 'EUR',
        date: 'el-GR',
        currencySymbol: '€'
    },
    {
        language: 'Hebrew',
        locale: 'iw',
        flagLang: 'il',
        currency: 'ILS',
        date: 'iw-IL',
        currencySymbol: '₪'
    },
    {
        language: 'Hindi',
        locale: 'hi',
        flagLang: 'in',
        currency: 'INR',
        date: 'hi-IN',
        currencySymbol: '₹'
    },
    {
        language: 'Irish',
        locale: 'ga',
        flagLang: 'ie',
        currency: 'EUR',
        date: 'ga-IE',
        currencySymbol: '€'
    },
    {
        language: 'Italian',
        locale: 'it',
        flagLang: 'it',
        currency: 'EUR',
        date: 'it-IT',
        currencySymbol: '€'
    },
    {
        language: 'Korean',
        locale: 'ko',
        flagLang: 'kr',
        currency: 'KRW',
        date: 'ko-KR',
        currencySymbol: '₩'
    },
    {
        language: 'Persian',
        locale: 'fa',
        flagLang: 'ir',
        currency: 'IRR',
        date: 'fa-IR',
        currencySymbol: '﷼'
    },
    {
        language: 'Polish',
        locale: 'pl',
        flagLang: 'pl',
        currency: 'PLN',
        date: 'pl-PL',
        symbol: 'zł'
    },
    {
        language: 'Portuguese',
        locale: 'pt',
        flagLang: 'pt',
        currency: 'EUR',
        date: 'pt-PT',
        currencySymbol: '€'
    },
    {
        language: 'Russian',
        locale: 'ru',
        flagLang: 'ru',
        currency: 'RUB',
        date: 'ru-RU',
        currencySymbol: '₽'
    },
    {
        language: 'Spanish',
        locale: 'es',
        flagLang: 'es',
        currency: 'EUR',
        date: 'es-ES',
        currencySymbol: '€'
    },
    {
        language: 'Swedish',
        locale: 'sv',
        flagLang: 'se',
        currency: 'SEK',
        date: 'sv-SE',
        currencySymbol: 'kr'
    },
    {
        language: 'Tagalog',
        locale: 'tl',
        flagLang: 'ph',
        currency: 'PHP',
        date: 'tl-PH',
        currencySymbol: '₱'
    },
    {
        language: 'Vietnamese',
        locale: 'vi',
        flagLang: 'vn',
        currency: 'VND',
        date: 'vi-VN',
        currencySymbol: '₫'
    },
];


export const JOBLIST_BREADCRUMB: BreadcrumbModel[] = [
    {
        id: 'configuration',
        name: 'navigation.configuration.configurationLabel',
        url: ''
    },
    {
        id: 'settings',
        name: 'settingsLabel',
        url: ''
    },
    {
        id: 'config.settings.jobList',
        name: 'joblistSettingsLabel',
        url: '/config/settings/jobList',
        key: 'joblist-settings'
    }
]

export const CUSTOMTEXT_BREADCRUMB: BreadcrumbModel[] = [
    {
        id: 'configuration',
        name: 'navigation.configuration.configurationLabel',
        url: ''
    },
    {
        id: 'settings',
        name: 'settingsLabel',
        url: ''
    },
    {
        id: 'config.settings.customtext',
        name: 'navigation.configuration.customization.customTextKeyLabel',
        url: '/config/settings/custom-text',
        key: 'custom-text'
    }
]

export const GROUP_BREADCRUMB: BreadcrumbModel[] = [
    {
        id: 'management',
        name: 'navigation.management.managementLabel',
        url: ''
    },
    {
        id: 'groups',
        name: 'groupLabel',
        url: '/groups',
        key: 'group-list'
    }
]

export enum LocalStorageKeys {
    IS_PARTNER = 'IsPartner',
    THEME_CODE = 'ThemeCode',
    ENABLE_SIGN_UP = 'EnableSignUp',
    DOMAIN_NAME = 'DomainName',
    URL = 'URL',
    TIER = 'Tier',
    CUSTOMER_ID = 'customerId',
    AUTH_PROVIDERS = 'authProviders',
    GLOBAL_DECIMAL_SETTING = 'GlobalDecimalSetting',
    DECIMAL_SEPARATOR = 'decimalSeparator',
    CUSTOMER_TYPE = 'customerType',
    LOGIN_CUSTOMER_LOGO = 'loginCustomerLogo',
    DISPLAY_UPLOAD = 'displayUpload',
    AUTOMATIC_DELIVERY = 'automaticDelivery',
    LANG_LOCALE = 'langLocale',
    DATE_BY_COUNTRY = 'dateByCountry',
    CURRENCY = 'currency',
    AUTO_DISMISSED_ENABLED = 'autoDismissedEnabled',
    AUTO_DISMISSED_DURATION = 'autoDismissedDuration'
}
